import { Link, useNavigate } from 'react-router';
import { faGear } from '@fortawesome/free-solid-svg-icons/faGear';
import { MenuItem, MenuSection, Header } from 'react-aria-components';
import { MenuButton } from 'components/menu-button/MenuButton';
import { configMenuDefinition } from '@layouts/toolbar/user/configMenuDefinition';
import { useHasPermission } from '@hooks/has-permission/useHasPermission';



const ConfigMenu = () => {

	const navigate = useNavigate();
	const hasPermission = useHasPermission();

	return (
		<MenuButton
			icon={faGear}
			autoFocus={false}
			onAction={(key: string | number | bigint) => {
				navigate(String(key));
			}}>
			{configMenuDefinition.map(x => x.items && x.items.length > 0
				?
					(<MenuSection key={x.id}>
						<Header>{x.name}</Header>
						{x.items.map(y =>
							<MenuItem
								key={y.id}
								id={y.id}
								textValue={y.name}
								isDisabled={y.requiredRoles ? !hasPermission(y.requiredRoles) : false}>
									<Link to={y.id}>{y.name}</Link>
							</MenuItem>
						)}
					</MenuSection>)
				:
					(<MenuItem
						key={x.id}
						id={x.id}
						textValue={x.name}
						isDisabled={x.requiredRoles ? !hasPermission(x.requiredRoles) : false}>
							<Link to={x.id}>{x.name}</Link>
					</MenuItem>)
			)}
		</MenuButton>
	);
}

export default ConfigMenu;